import { CatalogStore } from "../../store/modules/catalog";
import { DepositData } from "../../data/depositData";
import { DepositCurrencyTypeData } from "../../data/depositCurrencyTypeData";
import { BankProductData } from "../../data/bankProductData";
import { Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

export class DepositTypesListVue extends Vue {
  /* data: */

  // флаг открытия модального окна
  modalFlag: boolean = false;

  // заголовок модального окна
  dialogCaption: string = '';

  // детали для модального окна
  details: Array<any> = [];

  modalDeposit: DepositCurrencyTypeData = null;

  /* computed: */

  // хранлище данных
  get catalogStore(): CatalogStore {
    return getModule(CatalogStore, this.$store);
  }

  // массив хранящий все типы вкладов
  get depositsList(): Array<DepositData> {
    return this.catalogStore.bankProducts.find((product: BankProductData) => product.ViewName === 'depositTypesList')?.Childs;
  }

  /* methods: */

  getCurrencys(deposit: DepositData): Array<string> {
    const res: Array<string> = [];
    deposit.CurrencyChilds.map((depo: DepositCurrencyTypeData) => {
      if (!res.includes(depo.currency))
        res.push(depo.currency);
    });
    return res;
  }

  getTerms(deposit: DepositData): Array<string> {
    const res: Array<string> = [];
    deposit.CurrencyChilds.map((depo: DepositCurrencyTypeData) => {
      if (depo.currency == deposit.ActiveCurrency && !res.includes(depo.term))
        res.push(depo.term);
    });
    return res;    
  }

  // нужно ли рисовать пикер периодов вклада
  isDepositsWithTerms(deposit: DepositData): boolean {
    return deposit.GroupKey.split('|')[1] === 'term';
  }

  // находит выбранный тип вклада
  getActiveDepositChild(deposit: DepositData): DepositCurrencyTypeData {
    const resDepo: DepositCurrencyTypeData = deposit.CurrencyChilds.find((curDepo: DepositCurrencyTypeData) => {
      return curDepo.currency == deposit.ActiveCurrency && curDepo.term == deposit.ActiveTerm;
    });
    return resDepo ?? new DepositCurrencyTypeData();
  }

  // изменяет выбранный тип вклада по валюте
  setActiveCurrency(deposit: DepositData, currency: string): void {
    if (deposit) {
      deposit.ActiveCurrency = currency;
      const terms: Array<string> = this.getTerms(deposit);
      if (terms.length)
        deposit.ActiveTerm = terms[0];
    }
  }

  // изменяет выбранный тип вклада по валюте и периоду
  setActiveTerm(deposit: DepositData, term: string, currency: string): void {
    if (deposit) {
      deposit.ActiveCurrency = currency;
      deposit.ActiveTerm = term;
    }
  }

  // октрыть модальное окно 
  modalOpen(deposit: DepositData): void {
    if (deposit) {
      const keys: Array<string> = 
        [
         'type',
         'term',
         'currency',
         'rate',
         'minSum',
         'maxSum',
         'depReplenishment',
         'expOperations',
         'interestPayProc',
         'earlyReturnRate',
         'earlyDissolution',
         'extendingTerm',
         'informationExchange',
         'otherConditions'
        ];
      const product: BankProductData = this.catalogStore.bankProducts.find((product: BankProductData) => product.ViewName === 'depositTypesList');
      this.modalFlag = true;
      this.dialogCaption = deposit.Caption;
      const activeDepo: DepositCurrencyTypeData = deposit.CurrencyChilds.find((curDepo: DepositCurrencyTypeData) => {
        return curDepo.currency == deposit.ActiveCurrency && curDepo.term == deposit.ActiveTerm;
      });
      this.modalDeposit = activeDepo;
      this.details = [];
      if (activeDepo) {
        keys.map((key: string) => {
          let textVal: string = '';

          if (key === 'minSum' || key === 'maxSum')
            textVal = !isNaN(parseFloat(activeDepo[key].toString())) ?  `${activeDepo[key].toLocaleString("ru")} ${activeDepo.currency}` : activeDepo[key].toString();
          else
            textVal = activeDepo[key];

          this.details.push({
            textVal: textVal,
            name: product.captions[key]
          })
        });
      }
    }
  }

  // закрыть модальное окно
  closeModal(): void {
    this.details = [];
    this.modalFlag = false;
    this.dialogCaption = '';
    this.modalDeposit = null;
  }

  // переход в операцию открытие вклада
  openDeposit(): void {
    if (this.modalDeposit) {
      let initDataStringRes: string = '?';
      for (const key in this.modalDeposit.initData) {
        const item: any = this.modalDeposit.initData[key];
        initDataStringRes += `${key}=${item}&`
      }
      this.$router.push(`/operation/0/${this.modalDeposit.operId}${initDataStringRes}_application=1`);
    }
  }

}
